import './App.css'
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Home from './components/pages/Home'
import Login from './components/pages/auth/Login'
import ForgetPassword from './components/pages/auth/ForgetPassword';
import ResetPassword from './components/pages/auth/ResetPassword';
import FileManagement from './components/pages/files/FileManagement';
import HospitalManagement from './components/pages/hospital/HospitalManagement';
import UserManagement from './components/pages/users/UserManagement';
import AdminLayout from './components/layout/AdminLayout';
import AuthLayout from './components/layout/AuthLayout';
import { AuthService } from './services/auth.service';
import PropTypes from 'prop-types';

const ProtectedRoute = ({ allowedRoles }) => {
  const isAuthenticated = AuthService.isAuthenticated();
  const userRole = AuthService.getUserRole();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/" replace />;
  };

  return <Outlet />;
  
};

const PublicRoute = () => {
  const isAuthenticated = AuthService.isAuthenticated();
  
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

function App() {
  return (
    <BrowserRouter future={{ 
      v7_startTransition: true,
      v7_relativeSplatPath: true 
    }}>
      <Routes>
        {/* Public Routes */}
        <Route element={<PublicRoute />}>
          <Route element={<AuthLayout />}>
            <Route path="login" element={<Login />} />
            <Route path="forget-password" element={<ForgetPassword />} />
            <Route path="reset-password" element={<ResetPassword />} />
          </Route>
        </Route>

        {/* Protected Routes */}
          <Route element={<AdminLayout />}>
            <Route element={<ProtectedRoute allowedRoles={['systemAdmin', 'admin', 'user', 'guest']} />}>
              <Route path="/" element={<Home />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={['systemAdmin', 'admin', 'user']} />}>
              <Route path="files" element={<FileManagement />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={['systemAdmin', 'admin']} />}>
              <Route path="hospitals" element={<HospitalManagement />} />            
              <Route path="users" element={<UserManagement />} />
            </Route>
          </Route>

        {/* Catch all route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
ProtectedRoute.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired
};



export default App